import { baseApi, createEndpointBuilder } from '@/shared/api';
import { API_TAGS } from '@/shared/api/tags';
import type {
  ChangePasswordRequest,
  ChangeDefaultLanguageRequest,
  UserPreferenceOperationResponse
} from '../model/types';

const userEndpoint = createEndpointBuilder('/api/v2/users');

export const userPreferencesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    changePassword: builder.mutation<UserPreferenceOperationResponse, ChangePasswordRequest>({
      query: (passwordData) => ({
        url: userEndpoint('/password'),
        method: 'POST',
        body: passwordData
      })
    }),

    changeDefaultLanguage: builder.mutation<UserPreferenceOperationResponse, ChangeDefaultLanguageRequest>({
      query: (languageData) => ({
        url: userEndpoint('/language'),
        method: 'POST',
        body: languageData
      }),
      invalidatesTags: [API_TAGS.LAYOUT]
    })
  })
});

export const { useChangePasswordMutation, useChangeDefaultLanguageMutation } = userPreferencesApi;
